<template>
  <v-card>
    <v-card-title>
      <h2>{{ $t('report.sales_summary') }}</h2>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :loading="detailsLoading"
        :options.sync="pagination"
        :headers="headers"
        :items="salesSummary"
        :no-data-text="$t('table_no_data')"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td align="center">{{ item.coil_number || '-'}}</td>
            <td align="center">{{ item.quantity }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    salesSummary: Array,
    detailsLoading: Boolean
  },

  data () {
    return {
      pagination: {
        sortBy: ['quantity'],
        descending: true,
        itemsPerPage: 10
      }
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('report.product'), value: 'name' },
        { text: this.$t('report.coil_number'), value: 'coil_number', align: 'center' },
        { text: this.$t('report.quantity'), value: 'quantity', align: 'center' }
      ]
    }
  }
}
</script>
